export default "__VITE_ASSET__DgtXEikd__"